import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, FieldArray, formValueSelector } from 'redux-form';
import { FormGroup, Label, Collapse, Modal, ModalBody } from 'reactstrap';
import Aux from '../../../system/containers/Aux';

import Wysiwyg from '../../../system/fields/Wysiwyg';
import FileUpload from '../../../system/fields/FileUpload';
import AddressSearch from '../../../system/fields/AddressSearch';
import SelectDropdown from '../../../system/fields/SelectDropdown';
import * as validations from '../../../system/utils/Validation';

import DealNewHotelWrapper from './DealNewHotelWrapper';
import DealNewCityWrapper from './DealNewCityWrapper';
import TextInput from '../../../system/fields/TextInput';
import CreatableSelect from '../../../system/fields/CreatableSelect';

import Guides from './Guides';

class CruiseLegs extends Component {
  constructor(props, leg, index, OIndex,fields) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.toggleHotel = this.toggleHotel.bind(this);
    this.toggleShip = this.toggleShip.bind(this);
    this.state = {
      collapse: true,
      hotelToggle: false,
      shipToggle: false,
    };
  }

  toggle() {
    this.setState({ collapse: !this.state.collapse });
  }

  toggleShip() {
    this.setState({
      shipToggle: !this.state.shipToggle,
    });
  }

  toggleHotel() {
    this.setState({
      hotelToggle: !this.state.hotelToggle,
    });
  }

  render() {
    return (
      <Aux>
        {!this.state.collapse && (
          <div className='toggle' onClick={this.toggle}>
            <i className='fas fa-eye' /> <span>Expand</span>
          </div>
        )}
        {this.state.collapse && (
          <div className='toggle' onClick={this.toggle}>
            <i className='fas fa-eye-slash' /> <span>Collapse</span>
          </div>
        )}

        <div className='top-field'>
          <Label>Search Tags</Label>
          <Field
            name='search_tags'
            component={SelectDropdown}
            labelKey='value'
            valueKey='id'
            options={this.props.searchTags}
            autoFocus={true}
            multi
          />
        </div>
        <div className='top-field'>
          <Label>Ship</Label>
          <Field
            name={`${this.props.leg}.leg_detail.ship`}
            placeholder='Enter Ship'
            component={SelectDropdown}
            options={this.props.ships}
            labelKey={'name'}
            valueKey={'id'}
            type='text'
            validate={validations.required}
          />
          {/* <a href='#' role='button' onClick={this.toggleShip}>
            Add Ship
          </a> */}
          <Modal isOpen={this.state.shipToggle} toggle={this.toggleShip}>
            <ModalBody>
              <DealNewCityWrapper />
            </ModalBody>
          </Modal>
        </div>

        <Collapse isOpen={this.state.collapse}>
          <div className='row'>
            <FormGroup className='col-12 col-md-6'>
              <Label>Destination Tags</Label>
              <Field
                name={`${this.props.leg}.leg_detail.tags`}
                component={CreatableSelect}
                labelKey={'value'}
                valueKey={'id'}
                options={this.props.tags}
                multi
              />
            </FormGroup>
            <FormGroup className='col-12 col-md-6'>
              <Label>Day From - To</Label>
              <Field
                name={`${this.props.leg}.leg_detail.day_from_to`}
                component={TextInput}
                validate={validations.required}
              />
            </FormGroup>
            <FormGroup className='col-12'>
              <Label htmlFor='email'>Summary</Label>
              <Field
                name={`${this.props.leg}.leg_detail.summary`}
                component={Wysiwyg}
                placeholder='Sub Title'
                type='text'
                size='sm'
              />
            </FormGroup>
          </div>

          <div className='row'>
            <FormGroup className='col-12'>
              <Label htmlFor='email'>Images</Label>
              <Field
                name={`${this.props.leg}.leg_detail.images`}
                component={FileUpload}
                multiple={true}
                files={false}
                images={true}
                type='text'
                className='form-control'
              />
            </FormGroup>
          </div>

          <div className={'row'} style={{ padding: '0, 25px' }}>
            <FormGroup className={'col-8 offset-2'}>
              <Label>{'Itinerary'}</Label>
              <FieldArray
                name={`${this.props.leg}.guide`}
                tour={this.props.hotels}
                component={Guides}
                CLIndex={this.props.index}
                OIndex={this.props.OIndex}
              />
            </FormGroup>
          </div>
        </Collapse>
      </Aux>
    );
  }
}

const selector = formValueSelector('DealForm');

const mapStateToProps = (state, ownProps) => {
  return {
    hotels: state.overview.hotels,
    ships: state.overview.ships,
    cruiseLines: state.overview.cruiseLines,
    tags: state.overview.tags,
    hasHotel: selector(state, `${ownProps.leg}.leg_detail.hotel`),
    searchTags: state.overview.searchTags,
  };
};

export default connect(mapStateToProps)(CruiseLegs);



// WEBPACK FOOTER //
// ./src/containers/Deals/components/CruiseLegs.jsx